module.exports = __webpack_public_path__ + "img/virtualbox.6d2d03b.svg";